import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Spin } from 'antd'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import dashboardApi from '../../api/dashboard.api'
import { userState } from '../../store/user'
import '../../styles/home.scss'
import PeriodSearchFilter from '../shared/PeriodSearchFilter'

const UserDashboard = () => {
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(true)
  const [dateType, setDateType] = useState('')
  const [searchOptions, setSearchOptions] = useState({
    startDate: dayjs().startOf('day'),
    // endDate: dayjs().endOf('day'),
  })
  const [userStatistics, setUserStatistics] = useState({
    visitCnt: 0,
    newCnt: 0,
    existingCnt: 0,
    libreLiveCnt: 0,
    // bloodSugarScanInUseCnt: 0,
    // bloodSugarScanUsedCnt: 0,
    libre_connection_count: 0,
  })

  useEffect(() => {
    getUserStatistics()
    // getBloodSugarScanInUsed('IN_USE')
    // getBloodSugarScanInUsed('USED')
  }, [searchOptions.startDate])

  const getUserStatistics = async () => {
    setIsLoading(true)
    try {
      const baseDate = searchOptions.startDate || dayjs()
      const param = {
        startDate: dayjs(baseDate).format('YYYYMMDD'),
        endDate: dayjs(baseDate).format('YYYYMMDD'),
        userId: user.id,
      }
      const res = await dashboardApi.getUserStatistics(param)
      // console.log('dashboardApi res', res)
      if (res.data.code === 200) {
        setUserStatistics((prev) => ({
          ...prev,
          visitCnt: res.data.result.visit_count,
          newCnt: res.data.result.new_count,
          existingCnt: res.data.result.existing_count,
          libreLiveCnt: res.data.result.libre_count,
          libre_connection_count: res.data.result.libre_connection_count,
        }))
      } else {
        setUserStatistics((prev) => ({
          ...prev,
          visitCnt: 0,
          newCnt: 0,
          existingCnt: 0,
          libreLiveCnt: 0,
          // bloodSugarScanInUseCnt: 0,
          // bloodSugarScanUsedCnt: 0,
          libre_connection_count: 0,
        }))
      }
    } catch (e) {
      console.log('UserDashboard :: getUserStatistics error = ', e)
      setUserStatistics((prev) => ({
        ...prev,
        visitCnt: 0,
        newCnt: 0,
        existingCnt: 0,
        libreLiveCnt: 0,
        // bloodSugarScanInUseCnt: 0,
        // bloodSugarScanUsedCnt: 0,
        libre_connection_count: 0,
      }))
    } finally {
      setIsLoading(false)
    }
  }

  // const getBloodSugarScanInUsed = async (name) => {
  //   try {
  //     const param = {
  //       programTicketStatus: name,
  //     }
  //     const res = await dashboardApi.getBloodSugarScanStatistics(param)
  //     setUserStatistics((prev) => ({
  //       ...prev,
  //       bloodSugarScanInUseCnt:
  //         name === 'IN_USE' ? res.data : prev.bloodSugarScanInUseCnt,
  //       bloodSugarScanUsedCnt:
  //         name === 'USED' ? res.data : prev.bloodSugarScanUsedCnt,
  //     }))
  //   } catch (e) {
  //     console.log('etBloodSugarScanStatistics error = ', e)
  //   }
  // }

  const listTitle = (key) => {
    const titles = {
      visitCnt: { text: '방문자', color: '#117ffa' },
      newCnt: { text: '신규 회원', color: '#1ca717' },
      existingCnt: { text: '기존 회원', color: '#bbc71d' },
      libreLiveCnt: { text: 'CGM 라이브', color: '#FF6B6B' },
      libre_connection_count: { text: 'CGM 신규 연결', color: '#7B68EE' },
      // bloodSugarScanInUseCnt: { text: '스캔권 사용중', color: '#7B68EE' },
      // bloodSugarScanUsedCnt: { text: '스캔권 사용완료', color: '#FFA07A' },
    }

    return titles[key] || { text: '', color: '#191A1C' }
  }

  return (
    <Flex
      vertical
      gap={12}
      style={{ minWidth: '420px' }}
      className={`home-dashboard-component ${isLoading ? 'container-disable' : ''}`}
    >
      {isLoading && (
        <Spin
          className={'home-dashboard-loading'}
          indicator={<LoadingOutlined spin />}
          size={'large'}
        />
      )}
      <Flex align={'center'} className={'home-dashboard-title'}>
        <h2>가입/유입 통계</h2>
      </Flex>
      <PeriodSearchFilter
        dateType={dateType}
        setDateType={setDateType}
        searchOptions={searchOptions}
        setSearchOptions={setSearchOptions}
        singleDate
      />
      {/* <div className={`revenue-start-end-date-title`}>
        {dayjs().format('YYYY.MM.DD')}
      </div> */}
      <Flex
        justify={'space-between'}
        align={'center'}
        gap={10}
        style={{
          flexWrap: 'wrap',
          gap: '10px',
          paddingBottom: '12px',
        }}
      >
        {Object.keys(userStatistics).map((key, idx) => {
          const { text, color } = listTitle(key)
          return (
            <Flex
              vertical
              justify={'center'}
              align={'center'}
              gap={6}
              key={`user_list_${idx}`}
              className={'user-statistics-div'}
              style={{
                flex: '1 1 120px',
                minWidth: '120px',
              }}
            >
              <p className={'user-statistics-title'}>{text}</p>
              <Flex align={'center'} className={'user-statistics-info-wrap'}>
                <span style={{ color }} className={'user-statistics-info'}>
                  {userStatistics[key]?.toLocaleString()} 명
                </span>
              </Flex>
            </Flex>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default UserDashboard
